import React from "react";
import { formatCurrency } from "../../helpers/utils";
import { OrderStatusCell, PrepTimeCell } from "../../components/orderProgress";

export default function ProductRow({ item, onClick }) {

  // ✅ E-Barimt type (PERSON / COMPANY)
  const isCompany = item?.ebarimtType === "COMPANY";

  // ✅ Company үед регистр
  const registerNumber = item?.ebarimtRegister;

  return (
    <tr onClick={onClick} key={item.id} style={{ cursor: "pointer" }}>
      <td className="text-center">#{item?.orderCode}</td>

      {/* Хаяг + доор нь И-Баримтын төрөл */}
      <td className="text-center">
        <div>
          {item?.district?.name} {item.address}
        </div>

        <div
          style={{
            fontSize: 16,
            color: "#6c757d",
            marginTop: 2,
          }}
        >
          <span style={{ fontWeight: 600 }}>
            {isCompany ? "Байгууллага" : "Хувь хүн"}
          </span>

          {isCompany && registerNumber && (
            <span> | Регистер: {registerNumber}</span>
          )}
        </div>
      </td>

      <td className="text-center">
        {formatCurrency(item?.totalAmount)}
      </td>

      <td className="text-center">{item?.createdAt}</td>

      {/* Серверийн тоолуур + хугацаа сунгах, төлөв + жолооч (2026-09-17). */}
      <PrepTimeCell item={item} />
      <OrderStatusCell item={item} />
    </tr>
  );
}
